import { render, staticRenderFns } from "./detailExamin.vue?vue&type=template&id=d969342c&scoped=true&"
import script from "./detailExamin.vue?vue&type=script&lang=js&"
export * from "./detailExamin.vue?vue&type=script&lang=js&"
import style0 from "./detailExamin.vue?vue&type=style&index=0&id=d969342c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d969342c",
  null
  
)

export default component.exports